import axios from "axios";
const  tenants = {
    [ process.env.VUE_APP_BASE_URL]: {
    CF_BASE_URL:  process.env.VUE_APP_BASE_URL,
    DEFO_BASE_URL: process.env.VUE_APP_DEFORESTATION_BASE_URL,
    DEFO_API_BASE_URL: process.env.VUE_APP_DEFORESTRATION_API_BASE_URL,
    REPORTING_API_BASE_URL:  process.env.VUE_APP_DEFORESTRATION_REPORTING_API_BASE_URL
  },
  // Group 1: Default Tenant
    [process.env.VUE_APP_KENYA_BASE_URL]: {
    CF_BASE_URL: process.env.VUE_APP_KENYA_BASE_URL,
    DEFO_BASE_URL: process.env.VUE_APP_KENYA_DEFO_BASE_URL,
    DEFO_API_BASE_URL: process.env.VUE_APP_KENYA_DEFO_API_BASE_URL,
    REPORTING_API_BASE_URL: process.env.VUE_APP_KENYA_REPORTING_API_BASE_URL
  },

  // Group 2: Kenya Tenant

  // Add other tenant groups here in the future
};
export default {
async checkAuth(context, data) {
  // Iterate over each tenant configuration: [primaryUrl, urlGroup]
  for (const [primaryUrl, urlGroup] of Object.entries(tenants)) {
    
    // Skip if the environment variable for a key wasn't defined
    if (!primaryUrl || primaryUrl === 'undefined') {
      continue;
    }

    try {
      const response = await axios.post(`${primaryUrl}/login`, data);

      if (response.data?.success) {
        console.log(`✅ Login successful on tenant: ${primaryUrl}`);

        // 1. Set the main URL for default axios requests
        axios.defaults.baseURL = primaryUrl;

        // 2. Commit the user data
        context.commit('setUserData', response.data.data);

        localStorage.setItem('CF_BASE_URL', primaryUrl);
        localStorage.setItem('CF_DEFORESTATION_BASE_URL', urlGroup.DEFO_BASE_URL);
        localStorage.setItem('CF_DEFORESTATION_API_BASE_URL', urlGroup.DEFO_API_BASE_URL);
        localStorage.setItem('CF_REPORTING_API_BASE_URL', urlGroup.REPORTING_API_BASE_URL);


        return { success: 'ok' }; // Success!
      }
    } catch (error) {
      console.warn(`Login failed on tenant ${primaryUrl}, trying next...`);
    }
  }

  // If the loop finishes, all attempts have failed.
  throw new Error('Authentication failed on all available tenants.');
},

  async autoLogin(context) {
    const user = await JSON.parse(localStorage.getItem("user"));
    const token = await localStorage.getItem("token");
    const refToken = await localStorage.getItem("refreshtoken");
    if (user && token) {
      await context.commit("setUserData", user);
      await context.commit("setAuthToken", token);
      await context.commit("setRefreshToken", refToken);
    }
  },

  async logout(context) {
    // localStorage.removeItem('token');
    // localStorage.removeItem('user');
    // localStorage.removeItem('refreshtoken');
    context.commit("unsetUser");
    // Clear farmers data
    context.dispatch("memberData/clearFarmersOptions", null, { root: true });
    // await axios.post('/logout',{})
    //     .then( (response) => {
    //         console.log(response)
    //     })
    //     .catch( () => {
    //         context.commit('unsetUser');
    //     });
  },

  async forgotPassword(context, payLoad) {
    let type = payLoad.type;
    delete payLoad["type"];
    return await axios
      .post("/user/forgot-password/" + type, payLoad)
      .then((res) => {
        res = res.data;
        if (!res.success) {
          throw res.message;
        }
        context.commit("setTempToken", res.data.token);
      })
      .catch((err) => {
        throw err;
      });
  },

  async verifyForgotPasswordOtp(context, payLoad) {
    return await axios
      .post("/user/verify-otp/forgot-password", payLoad)
      .then((res) => {
        res = res.data;
        if (!res.success) {
          throw res.message;
        }
        context.commit("setAuthToken", res.data.token);
        // axios.defaults.headers.common['oauth-token'] = `${res.data.token}`
      })
      .catch((err) => {
        throw err;
      });
  },

  async createUserPassword(context, payLoad) {
    return await axios
      .post("/user/create-password", payLoad)
      .then((res) => {
        res = res.data;
        return res;
        // console.log('frg', res);
      })
      .catch((err) => {
        throw err;
      });
  },

  async refreshToken(context) {
    const token = context.getters.getAuthToken;
    const refershToken = context.getters.getRefreshToken;
    return await axios
      .post("/access-token", {
        accesstoken: token,
        refreshtoken: refershToken,
      })
      .then((res) => {
        res = res.data;
        if (!res.success) {
          context.dispatch("logout");
          throw res.message;
        }
        context.commit("setAuthToken", res.data.accesstoken);
        context.commit("setRefreshToken", res.data.refreshtoken);
      })
      .catch((err) => {
        throw err;
      });
  },

  async setModulePermittedActions(context, payload) {
    await context.commit("setModulePermittedActions", payload);
  },

  async setGlobalSettings(context, payload) {
    await context.commit("setGlobalSettings", payload);
  },
};
